import {
    Button,
    IconExclaimationTriangle,
    Inline,
    Modal,
    ModalBody,
    ModalFooter,
    Stack,
    toast
} from '@7shifts/sous-chef';
import { impersonateUser } from 'adminPanel/api/users';
import { User } from 'adminPanel/types';
import { __ } from 'i18n/translate';
import { useState } from 'react';

type Props = {
    user: User;
    onClose: () => void;
};

const ImpersonateModal = ({ user, onClose }: Props) => {
    const [isImpersonating, setIsImpersonating] = useState(false);
    const impersonate = () => {
        setIsImpersonating(true);
        impersonateUser(user.id)
            .then((data) => {
                console.log('data', data);
                localStorage.setItem(
                    'impersonatorToken',
                    localStorage.getItem('token') || ''
                );
                localStorage.setItem(
                    'impersonatorRefreshToken',
                    localStorage.getItem('refreshToken') || ''
                );
                localStorage.setItem('token', data.token);

                localStorage.setItem('refreshToken', data.refreshToken);
                localStorage.setItem('companyId', data.companyId);
                localStorage.setItem('userId', data.userId);
                localStorage.setItem(
                    'companyDueDate',
                    '2035-03-22T17:23:52.000Z'
                );
                localStorage.removeItem('ticketsPageFilters');
                window.location.href = '/';
            })
            .catch(() => {
                toast('Erro ao acessar a conta do usuário', 'danger');
            })
            .finally(() => {
                setIsImpersonating(false);
            });
    };

    return (
        <Modal header={__('adminpanel.impersonate')} onClose={onClose}>
            <ModalBody>
                <Inline>
                    <IconExclaimationTriangle color="banana-400" />
                    <Stack>
                        {__('adminpanel.impersonateModalWarning', {
                            name: user.name,
                            email: user.email
                        })}
                        {__('adminpanel.impersonateModalWarning2')}
                    </Stack>
                </Inline>
            </ModalBody>
            <ModalFooter
                actions={{
                    primary: (
                        <Button onClick={impersonate} loading={isImpersonating}>
                            {__('adminpanel.impersonate')}
                        </Button>
                    ),
                    secondary: (
                        <Button onClick={onClose}>{__('main.cancel')}</Button>
                    )
                }}
            />
        </Modal>
    );
};

export default ImpersonateModal;
